const CODE_MAP: Record<string, string> = {
  ERR_AUTH_TOKEN_INVALID: 'errors.auth_token_invalid',
  ERR_RBAC_FORBIDDEN: 'errors.rbac_forbidden',
  ERR_EVENT_NOT_FOUND: 'errors.not_found',
  ERR_CASE_NOT_FOUND: 'errors.not_found',
  ERR_PROJECT_NOT_FOUND: 'errors.not_found',
  ERR_NOT_FOUND: 'errors.not_found',
};

export function mapErrorCode(code: string | undefined): string {
  if (!code) return 'errors.unknown';
  return CODE_MAP[code] ?? 'errors.unknown';
}

interface BackendErrorShape {
  response?: { data?: { error?: { code?: string; message?: string } } };
}

export function getErrorMessage(err: unknown): string {
  if (!err) return 'errors.unknown';
  return mapErrorCode(getErrorCode(err));
}

/**
 * The backend's `ERR_*` code for a failed request, when it sent one. Callers
 * that must react to a specific failure (a name clash, say) need the code
 * itself; everything else should use `getErrorMessage`.
 */
export function getErrorCode(err: unknown): string | undefined {
  return (err as BackendErrorShape)?.response?.data?.error?.code;
}

/**
 * The backend's human-readable `message`, when it sent one.
 *
 * Most UI surfaces should use `getErrorMessage` so the text is translated. This
 * one exists for errors whose *content* is the point — an EWS rejection, say —
 * where a generic "something went wrong" throws away the only useful part.
 */
export function getErrorDetail(err: unknown): string {
  const message = (err as BackendErrorShape)?.response?.data?.error?.message;
  if (message) return message;
  return err instanceof Error ? err.message : String(err);
}
